import PropTypes from 'prop-types';
import ListToggleButton from './list_toggle_button';
import FitterReviewsList from './fitter_reviews_list';
import {
    CLOSED_STATE,
    FIRST_OPEN_STATE
} from '../../../../../../../_modules/reviews/toggle_list_items';
import Translation from '../../../../../translation/translation';

class FitterReviews extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            limitShownReviewsTo: FitterReviews.getShownReviewCountForButtonState(CLOSED_STATE)
        };
    }

    render() {
        return (
            <div className="fsf-station__detail">
              <h3 className="fsf-station__detail-headline">
                  <Translation translationKey="reviews-headline" />
              </h3>
              <div className="fsf-station__detail-contents">
                    <FitterReviewsList
                        reviews={this.props.reviews}
                        fsName={this.props.fsName}
                        limitShownReviewsTo={this.state.limitShownReviewsTo}
                    />
                    {this.props.reviews.length > 3 &&
                        <ListToggleButton
                            onChange={this.onListToggleButtonClick.bind(this)}
                        />
                    }
                </div>
            </div>
        );
    }

    onListToggleButtonClick(buttonState) {
        this.setState({
            limitShownReviewsTo: FitterReviews.getShownReviewCountForButtonState(buttonState)
        });
    }

    static getShownReviewCountForButtonState(buttonState) {
        if (buttonState === CLOSED_STATE) {
            return 3;
        } else if (buttonState === FIRST_OPEN_STATE) {
            return 5;
        } else {
            return 0;
        }
    }
}

FitterReviews.propTypes = {
    reviews: PropTypes.array,
    fsName: PropTypes.string,
};

FitterReviews.defaultProps = {
    reviews: [],
    fsName: '',
};

export default FitterReviews;
